import React from "react";
import styled from "styled-components";

const Title = styled.div`  
  text-transform: uppercase;
  font-size: 17px;
  color: #999999;
  padding-bottom:20px;
  padding-top:20px;
`;
const ChildSectionTitle = ({ id, children }) => (
  <Title id={id}>{children}</Title>
);
export default ChildSectionTitle;
